import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { CustomizationFlagQueries } from '@frontend/api-customization-flags';
import { useMerchants } from '@frontend/payments-hooks';

export const useTerminalSettings = (locationId: string | undefined) => {
  const { hasFullPayments } = useMerchants(locationId)['firstLocation'];
  const { isFeatureActiveInAllLocations } = CustomizationFlagQueries.useAggregateCustomizationFlagDetails({
    locationIds: locationId ? [locationId] : [],
    customizationFlag: Feature.PAYMENT_TERMINALS,
  });

  const hasTerminalsEnabled = hasFullPayments && isFeatureActiveInAllLocations;

  return { hasTerminalsEnabled };
};
